import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

type AllRolesState = Readonly<{
    isLoadingAllRoles: boolean;
    results: string[]
}>;

const initialState: AllRolesState = {
    isLoadingAllRoles: false,
    results: []
};

const reducer = {
    "Custom/AllRoles/BeginFetchingContents": (draft: Draft<AllRolesState>) => {
        draft.isLoadingAllRoles = true;
    },
    "Custom/AllRoles/SetContents": (draft: Draft<AllRolesState>, action: { results: string[] }) => {
        draft.results = action.results;
        draft.isLoadingAllRoles = false;
    },
    "Custom/AllRoles/CompletedFetchingContents": (draft: Draft<AllRolesState>) => {
        draft.isLoadingAllRoles = false;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
